import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { CSVLink } from "react-csv";

import { selectSetting } from "../../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../../hooks/reduxHooks";
import { AUTH_LEVELS } from "../../../../../lib/globals";
import { useIndexContext } from "../contexts/Index";
import normalizePhone from "../lib/normalizePhone";

interface CSVRow {
    team: string;
    ageLevel: string;
    league: string;
    coach: string;
    phone: string;
    email: string;
}

const CSVHeaders = [
    { label: "Team", key: "team" },
    { label: "Age Level", key: "ageLevel" },
    { label: "League", key: "league" },
    { label: "Coach/Contact", key: "coach" },
    { label: "Phone", key: "phone" },
    { label: "Email", key: "email" },
];

const ClubhouseDownload = (): React.JSX.Element | null => {
    const { user } = useAppSelector(state => state.auth);
    const { teams, filters } = useIndexContext();
    const [csvData, setCSVData] = useState<CSVRow[]>([]);

    const currentYear = parseInt(
        useAppSelector(state =>
            selectSetting(state, "majorybl_current_league_year"),
        )?.setting,
    );

    if (!user || !AUTH_LEVELS.leaguemanagement.includes(user.userLevel)) {
        return null;
    }

    const handleDownload = () => {
        const filteredData = teams
            .filter(t =>
                filters.search
                    ? t.name
                          .toLowerCase()
                          .includes(filters.search.toLowerCase()) ||
                      t.coach.email
                          .toLowerCase()
                          .includes(filters.search.toLowerCase()) ||
                      t.coach.firstName
                          .toLowerCase()
                          .includes(filters.search.toLowerCase()) ||
                      t.coach.lastName
                          .toLowerCase()
                          .includes(filters.search.toLowerCase()) ||
                      t.coach.phone
                          .toLowerCase()
                          .includes(filters.search.toLowerCase())
                    : true,
            )
            .filter(
                t => filters.activeLeague === t.currentAgeLevel.season.season,
            )
            .filter(t =>
                filters.ageLevels.filter && t.currentAgeLevel
                    ? filters.ageLevels.filter.includes(
                          t.currentAgeLevel?.ageLevel,
                      )
                    : true,
            )
            .filter(t =>
                filters.leagues.filter
                    ? t.leagues
                        ? t.leagues.some(
                              l =>
                                  l.year === currentYear &&
                                  filters.leagues.filter?.includes(l.name),
                          )
                        : false
                    : true,
            )
            .map(t => {
                const currentTeamsLeague = t?.leagues?.find(
                    l => l.year === currentYear,
                );

                return {
                    team: t.name,
                    ageLevel: t.currentAgeLevel?.ageLevel || "",
                    league:
                        currentTeamsLeague?.name ||
                        t.currentAgeLevel?.ageLevel ||
                        "",
                    coach: `${t.coach.firstName} ${t.coach.lastName}`,
                    phone: normalizePhone(t.coach.phone),
                    email: t.coach.email,
                };
            });

        setCSVData(filteredData);
    };

    return (
        <Row>
            <Col className="d-flex justify-content-end mt-4 mb-2">
                <CSVLink
                    data={csvData}
                    headers={CSVHeaders}
                    filename={`clubhouse-teams.${new Date().getTime()}.csv`}
                    className="btn btn-primary"
                    target="_blank"
                    onClick={handleDownload}
                >
                    Export Teams
                </CSVLink>
            </Col>
        </Row>
    );
};

export default ClubhouseDownload;
